import React, { Component } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import toggleDialogCreator from "shared/helpers/toggleDialogCreator";
import ConfirmationDialog from "./ConfirmationDialog";

export const CONFIRMATION_DIALOG = "CONFIRMATION_DIALOG";

export const toggleConfirmationDialog = dispatch => {
  const toggle = toggleDialogCreator(
    dispatch,
    "confirmation_dialog",
    "buyer_portal"
  );
  return dialogModel => {
    toggle(CONFIRMATION_DIALOG, dialogModel);
  };
};

class ConfirmationDialogContainer extends Component {
  render() {
    const { dialogModel, toggleDialog } = this.props;

    if (dialogModel) {
      return (
        <ConfirmationDialog
          {...dialogModel}
          open={!!dialogModel}
          onAsyncClose={() => {
            toggleDialog(CONFIRMATION_DIALOG, null);
          }}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = (state, props) => {
  const { module, id } = props;
  return {
    ...props,
    i18n: state.i18n,
    dialogModel: get(state, ["dialog", module, id, CONFIRMATION_DIALOG])
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { module, id } = props;
  return {
    toggleDialog: toggleDialogCreator(dispatch, id, module)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationDialogContainer);
